import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Target } from "lucide-react";

const colore = (pct) => (pct >= 100 ? ["bg-emerald-500", "text-emerald-700", "bg-emerald-50 border-emerald-200"] : pct >= 50 ? ["bg-amber-400", "text-amber-700", "bg-amber-50 border-amber-200"] : ["bg-red-500", "text-red-700", "bg-red-50 border-red-200"]);
const MSG = ["Obiettivo raggiunto, grande lavoro!", "Fantastico, continua così!", "Ce l'hai fatta: sei un esempio per il team!"];

function MeseRiga({ r }) {
  const pct = r.mese_obiettivo ? Math.round((r.mese_fatto / r.mese_obiettivo) * 100) : 0;
  const [bar, txt] = r.mese_obiettivo ? colore(pct) : ["bg-slate-300", "text-slate-500"];
  return (
    <div className="mt-2 pt-2 border-t border-black/5" data-testid={`obj-${r.chiave}-mese`}>
      <div className={`text-[11px] font-bold ${txt}`}>Mese: <span data-testid={`obj-${r.chiave}-mese-fatto`}>{r.mese_fatto}</span> / {r.mese_obiettivo || "—"}</div>
      <div className="mt-1 h-1.5 rounded-full bg-white/70 border border-black/5 overflow-hidden">
        <div className={`h-full rounded-full ${bar} transition-[width] duration-700`} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
    </div>
  );
}

export function ObiettiviContatori() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/obiettivi-team/me").then((r) => setD(r.data.righe)).catch(() => setD([])); }, []);
  if (!d || !d.length) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-testid="mg-contatori-obiettivi">
      {d.map((r, i) => {
        const pct = r.obiettivo ? Math.round((r.fatto / r.obiettivo) * 100) : 0;
        const [bar, txt, box] = r.obiettivo ? colore(pct) : ["bg-slate-300", "text-slate-500", "bg-white border-[var(--border)]"];
        return (
          <div key={r.chiave} className={`rounded-2xl border-2 p-4 ${box}`} data-testid={`obj-${r.chiave}`}>
            <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-600"><Target size={13} /> {r.label}</div>
            <div className="mt-1 font-display text-3xl font-extrabold"><span data-testid={`obj-${r.chiave}-fatto`}>{r.fatto}</span>
              <span className="text-base text-slate-500 font-bold"> / {r.obiettivo || "—"}</span></div>
            <div className="mt-2 h-2.5 rounded-full bg-white/70 border border-black/5 overflow-hidden">
              <div className={`h-full rounded-full ${bar} transition-[width] duration-700`} style={{ width: `${Math.min(100, pct)}%` }} />
            </div>
            <div className={`mt-1.5 text-[11px] font-semibold ${txt}`} data-testid={`obj-${r.chiave}-msg`}>
              {!r.obiettivo ? "Obiettivo non ancora impostato" : pct >= 100 ? MSG[i % MSG.length] : `${pct}% dell'obiettivo`}
            </div>
            <MeseRiga r={r} />
          </div>
        );
      })}
    </div>
  );
}
